import { useNavigate } from 'react-router-dom'

import copyJson from '../../demo/fixtures/w3/copy.json'
import { useChain } from '../../demo/selectors/chain'
import { Button, Card, CardHead, Chip, GlossaryText } from '../../ui'
import styles from './TodoCard.module.css'

interface CopyFixture {
  todoEmpty: { title: string; sub: string }
}

const copy = copyJson as unknown as CopyFixture

const buttonLabels: Partial<Record<'01' | '02' | '03' | '04' | '05' | '06' | '07' | '08', string>> = {
  '07': '前往处理',
  '08': '10 月 1 日前确认即可',
}

function SparkIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3l1.9 5.6L19.5 10l-5.6 1.9L12 17.5l-1.9-5.6L4.5 10l5.6-1.4z" />
    </svg>
  )
}

function ArrowIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 12h15M13 6l6 6-6 6" />
    </svg>
  )
}

export function TodoCard() {
  const navigate = useNavigate()
  const chain = useChain()
  const items = chain.steps.filter(
    (step) => step.requiresDecision && (step.status === 'awaiting_user' || step.status === 'pending'),
  )
  const pendingCount = items.length

  return (
    // w3 清册的 todo-card 与第二波已上线的 overview-todo 指向同一张卡；锚点不可改。
    <Card data-scope="overview-todo">
      <CardHead
        title={(
          <>
            <span className={styles.aiBadge}><SparkIcon />AI</span>
            <span data-role="digest-title">今日待确认 · {pendingCount} 项</span>
          </>
        )}
      />
      <p className={styles.headNote}>其余 {chain.steps.length - pendingCount} 步已由 AI 自动完成</p>
      {pendingCount === 0 ? (
        <div className={styles.empty} data-scope="todo-empty">
          <p className={styles.emptyTitle}>{copy.todoEmpty.title}</p>
          <p className={styles.emptySub}>{copy.todoEmpty.sub}</p>
        </div>
      ) : (
        <div className={styles.body}>
          {items.map((step) => {
            const awaiting = step.status === 'awaiting_user'
            const buttonLabel = buttonLabels[step.id] ?? '前往处理'
            return (
              <div
                className={`${styles.item} ${awaiting ? styles.itemAwaiting : ''}`}
                data-role={`item-${step.id}`}
                key={step.id}
              >
                <Chip className={`${styles.stepChip} ${awaiting ? styles.stepChipWarn : ''}`}>
                  第 {step.id} 步 · {step.name}
                </Chip>
                <div className={styles.itemTitle}>{step.trio.action}</div>
                <div className={styles.itemBasis}><GlossaryText text={step.trio.basis} paren /></div>
                <Button
                  className={styles.itemButton}
                  variant={awaiting ? 'primary' : 'ghost'}
                  data-role={`go-${step.id}`}
                  onClick={() => { void navigate(step.route) }}
                >
                  {buttonLabel}
                  {awaiting ? <ArrowIcon /> : null}
                </Button>
              </div>
            )
          })}
        </div>
      )}
    </Card>
  )
}
